import ArticleLayout from "@/pages/articles/components/ArticleLayout";

export default function LuchshieNahodkiYoybuy() {
  return <ArticleLayout slug="luchshie-nahodki-yoybuy" />;
}